import React, { useEffect, useState } from "react"

import ImageGallery from "@/components/ImageGallery/v3/ImageGallery"
import Styles from "@/components/MultiFinshProductBundle/styles/ImageGalleryUI.module.scss"

import CONSTANTS from "@/constants/index"
import { useSelector } from "react-redux"
import { selectGenericState } from "@/store/features/genericSlice"

const ImageGalleryUI = props => {
  const {
    data = [],
    layerImageData = {},
    config = {},
    productInfoBundle = [],
  } = props || {}

  const swatchUrl = CONSTANTS.COLOR_FILE_URL
  const { authorData = {} } = useSelector(selectGenericState)
  const { presetConfigs = "{}", pdpDesktopImage = "" } = authorData ?? {
    presetConfigs: "{}",
    pdpDesktopImage: "",
  }
  const presetConfigObject = JSON.parse(presetConfigs)
  const { general: { scene7AccountName = "PAWEB" } = {} } = config

  const [initialImgAlt, setInitialImgAlt] = useState("")
  const [initialImgUrl, setInitialImgUrl] = useState("")
  const { label = "", assetId = "" } = data[0] || {}

  useEffect(() => {
    if (label && assetId) {
      setInitialImgAlt(label)
      setInitialImgUrl(assetId)
    }
  }, [label, assetId])

  return (
    <div className={Styles.ImageGalleryUI}>
      <ImageGallery
        data={data}
        presetConfigObject={presetConfigObject}
        swatchUrl={swatchUrl}
        assetAccountName={scene7AccountName}
        initialImgAlt={initialImgAlt}
        initialImgUrl={initialImgUrl}
        layerImageData={layerImageData}
        pdpDesktopImage={pdpDesktopImage}
        productInfo={productInfoBundle}
      />
    </div>
  )
}

export default React.memo(ImageGalleryUI)
